import React from 'react';
import type { WebResult } from '../../api/OasisBackendApi';

interface WebSearchResultsProps {
  data: {
    results: WebResult[];
  };
}

const WebSearchResults: React.FC<WebSearchResultsProps> = ({ data }) => {
  const { results } = data;

  if (!results || results.length === 0) {
    return (
      <div className="text-sm text-gray-200">
        No search results found.
      </div>
    );
  }

  return (
    <div className="mt-4">
      <div className="flex overflow-x-auto gap-4 pb-4 snap-x snap-mandatory" style={{ minHeight: '200px' }}>
        {results.map((result, idx) => (
          <div key={idx} className="snap-center shrink-0 w-48 flex-shrink-0">
            <div 
              className="h-full rounded-lg transition-all duration-200 hover:scale-[1.02]"
              style={{ 
                backgroundColor: 'var(--rhea-card-bg)',
                border: '1px solid var(--rhea-card-border)'
              }}
            >
              <a 
                href={result.url} 
                target="_blank" 
                rel="noopener noreferrer"
                className="block h-full p-3"
              >
                {result.profile?.img && (
                  <div className="mb-2">
                    <img 
                      src={result.profile.img} 
                      alt={result.profile.name || 'Profile'} 
                      className="w-10 h-10 rounded-full object-cover mx-auto"
                    />
                  </div>
                )}
                <h3 
                  className="text-sm font-medium mb-1 line-clamp-2 hover:underline text-center"
                  style={{ color: 'var(--rhea-accent-primary)' }}
                >
                  {result.title || result.url}
                </h3>
                {result.profile?.name && (
                  <div 
                    className="text-xs text-center mb-2"
                    style={{ color: 'var(--rhea-text-secondary)' }}
                  >
                    {result.profile.name}
                  </div>
                )}
                <p 
                  className="text-xs line-clamp-3 text-center"
                  style={{ color: 'var(--rhea-text-secondary)' }}
                >
                  {result.text}
                </p>
                <div className="mt-2 flex justify-center">
                  <svg 
                    className="w-4 h-4" 
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                    style={{ color: 'var(--rhea-text-secondary)' }}
                  >
                    <path 
                      strokeLinecap="round" 
                      strokeLinejoin="round" 
                      strokeWidth={2} 
                      d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" 
                    />
                  </svg>
                </div>
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WebSearchResults; 